import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '@components/Comman/Header';
import { Table, Space, Switch, message, Tag, Popconfirm, Tooltip, Button} from 'antd';
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useSelector, useDispatch } from 'react-redux';
import { deleteBusinessAction, exportBusinessAction, getAllBusinesses, updateBusinessStatus } from '../../actions/business';
import { formatAndCapitalizeString } from '@utils/comman';
import SearchFilter from '@components/Comman/TableFilter/SearchFilter';
import { getAllAdminNotificationCount, updateReferrerNotificationCount } from '../../actions/refer';

interface DataType {
    adminId: number;
    key: string;
    businessName: string;
    contactPerson: string;
    category: string;
    Admin: any;
}

const AllBusinesses = () => {
    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state: any) => state?.General);
    const userData = useSelector((state: any) => state?.Auth?.user);
    const userRoleId = userData?.data?.roleId;

    useEffect(() => {
        const payload = { limit: pageSize, page, role: userRoleId };
        handleBusiness(payload);
    }, [page, pageSize, dispatch]);

    useEffect(()=> {
        dispatch(updateReferrerNotificationCount({resetType: 'admin', role: userRoleId }, (res:any)=>{
            dispatch(getAllAdminNotificationCount({}, (res:any)=>{}))
        }))
    }, [])

    const handleBusiness = (payload:any)=>{
        dispatch(
            getAllBusinesses(payload, (resp: any) => {
                if (resp?.status === 200) {
                    setData(resp?.data);
                    setPagination(resp?.pagination);
                }
            })
        );
    }
    const handleReminderEmail = () => {

    }

    const handleDeleteBusiness = (payload:any)=>{
        const data = {
            id: payload?.Admin?.id,
        }
        dispatch(
            deleteBusinessAction(data, (resp: any) => {
                if (resp?.status === 200) {
                    const payload = { limit: pageSize, page, role: userRoleId };
                    handleBusiness(payload);
                }
            })
        );
    }

    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleStatusChange = (checked : any,  record : any) =>{
       console.log(checked, record)
       const payload = { isActive: checked, id: record.adminId };
        dispatch(
            updateBusinessStatus(payload, (resp: any) => {
                if (resp?.status === 200) {
                    const newData = data.map((result) => {
                        if (result.adminId === record.adminId) {
                            return {
                                ...result,
                                Admin: {
                                    ...result?.Admin,
                                    isActive: checked,
                                },
                            };
                        }
                        return result;
                    });
                    setData(newData);
                }
            })
        );
    }

    const columns: ColumnsType<DataType> = [
        {
            title: 'Business Name',
            dataIndex: 'businessName',
            key: 'businessName',
            sorter: (a, b) => a.businessName.localeCompare(b.businessName),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Contact Person',
            dataIndex: 'contactPerson',
            key: 'contactPerson',
            sorter: (a, b) => a.contactPerson.localeCompare(b.contactPerson),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Contact Number',
            dataIndex: 'contactNumber',
            key: 'contactNumber',
            sorter: (a: any, b: any) => a.contactNumber.localeCompare(b.contactNumber),
            render: (text) => <>{text}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Email',
            dataIndex: 'Admin',
            key: 'email',
            render: (Admin) => <>{Admin?.email}</>,
            align: 'left',
            width: 150,
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            sorter: (a, b) => a.category.localeCompare(b.category),
            render: (text) => <>{formatAndCapitalizeString(text)}</>,
            align: 'center',
            width: 100,
        },
        {
            title: 'Total Referrals',
            dataIndex: 'Admin',
            key: 'referrals',
            render: (Admin) => <>{Admin?.totalReferrals}</>,
            align: 'center',
            width: 100,
        },
        {
            title: 'Total Referrers',
            dataIndex: 'Admin',
            key: 'referrers',
            render: (Admin) => <>{Admin?.totalReferr}</>,
            align: 'center',
            width: 100,
        },
        {
        title: 'ReferredBy',
        dataIndex: 'Admin',
        key: 'referredBy',
        render: (Admin) => Admin?.referredBy?.email ? Admin.referredBy.email : '--',
        align: 'center',
        width: 100,
        },
        {
            title: 'Business Setup',
            dataIndex: 'Admin',
            key: 'referrers',
            render: (Admin) => (
                <>
                    {Admin?.isSetupCompleted ? (
                        <Tag color='green'>Completed</Tag>
                    ) : (
                    //     <Tooltip title="Send setup reminder email">

                    // <Popconfirm
                    //     title="Are you sure you want to send email reminder to the business for completing setup?"
                    //     onConfirm={() => handleReminderEmail()}>
                        <Tag color='red' style={{cursor: "pointer"}}>Pending</Tag>
                        // </Popconfirm>
                        // </Tooltip>
                    )}
                </>
            ),
            align: 'center',
            width: 100,
        },
        {
            title: 'Status',
            dataIndex: 'Admin',
            key: 'isActive',
            render: (Admin, record) => (
                <Switch
                    checked={Admin?.isActive}
                    style={{
                        backgroundColor: Admin?.isActive
                            ? '#F47523'
                            : '#a9a9a9', // Green when active, red when inactive
                    }}
                    onChange={(checked) => handleStatusChange(checked, record)}
                />
            ),
            align: 'center',
            width: 100,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Link
                        to={'/super-admin/view-business-details'}
                        state={{ adminId: record?.adminId }}
                    >
                        <EyeOutlined />
                    </Link>
                    <Tooltip title="Delete this Business">

                    <Popconfirm
                        title="Are you sure you want to delete this business?"
                        onConfirm={() => handleDeleteBusiness(record)}>

                    <div style={{cursor:"pointer", color:"#f47523"}}>
                        <DeleteOutlined />
                    </div>
                    </Popconfirm>
                            </Tooltip>
                </Space>
            ),
            align: 'center',
            width: 100,
        },
    ];

    const advanceBusinessList = [
        { value: "businessName", label: "Business Name" },
        { value: "contactPerson", label: "Contact Person" },
        { value: "category", label: "Category" },
    ];

    const handleSearch =(data:any)=> {
        let payload = {
            ...data,
            search: data?.search,
            limit: pageSize, 
            page, 
            role: userRoleId
        }
        handleBusiness(payload);       
    }

    const handleExport = () => {
        const payload = { role: userRoleId };

        dispatch(
            exportBusinessAction(payload, (resp: any) => {
                if (resp?.status === 200 && resp?.data) {
                    // Create a blob from the response data
                    const blob = new Blob([resp.data], { type: 'text/csv' });

                    // Create a download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;

                    // Optional: use Content-Disposition header for filename if available
                    const fileName = `business_list_${Date.now()}.csv`;
                    link.setAttribute('download', fileName);

                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url); // Clean up

                    message.success('Export successful!');
                } else if (resp?.status === 404) {
                    message.warning('No business records found.');
                } else {
                    message.error('Export failed.');
                }
            })
        );
    };


    return (
        <div>
            <Header pagTitle="All Businesses" />
            <div className="contentBody">
                <div className="bodycard">
                    <div className='d-flex justify-content-between align-items-center'>
                        <div>

                        <SearchFilter
                            filterList={advanceBusinessList}
                            searchTitle="Business Name, Contact Person, Category"
                            onSearch={(searchValue) => {
                                // Handle the search value here
                                // console.log(searchValue);
                                handleSearch(searchValue)
                            }}
                            />
                            </div>
                         <div> 

                        <Button
                            className='btn btn-primary' style={{height: '39px', fontSize: '12px'}} onClick={handleExport}>Export</Button>
                            </div>
                    </div>
                    <div className="cardContentbody">
                        <div className="responsivetable">
                            <Table
                                size='small'
                                columns={columns}
                                dataSource={data}
                                loading={isLoading}
                                pagination={{
                                    total: pagination?.totalItems || 0,
                                    pageSize,
                                    current: page,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['20', '50'],
                                }}
                                // scroll={{ y: 264, x: 800 }}
                                onChange={handleTableChange}
                                rowKey='id'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllBusinesses;

